'use client';

import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'surface-hairline rounded-[var(--radius-lg)] border border-border bg-card p-4 shadow-[var(--shadow-sm)] transition-all duration-motion-md ease-calm motion-reduce:transform-none motion-reduce:transition-none supports-[hover:hover]:hover:-translate-y-0.5 supports-[hover:hover]:hover:shadow-[var(--shadow-md)] sm:p-6',
        className
      )}
      {...props}
    />
  );
}
